import { useState, useEffect } from 'react';
import { isAdmin } from '../firebase/firestore';

export const useAdmin = (userId: string | null) => {
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!userId) {
        setIsAdminUser(false);
        setLoading(false);
        return;
      }

      try {
        const adminStatus = await isAdmin(userId);
        setIsAdminUser(adminStatus);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdminUser(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [userId]);

  return { isAdminUser, loading };
};
